export default __webpack_public_path__ + "static/media/respite1.c17409a8.jpeg";